import { classNames } from 'libs/react';
import { useState } from 'libs/react';
import { Button } from 'components/Button';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import './DealItemPickerOptionGroup.scss';
/**
 * @component DealItemPickerOptionGroup
 * @since 1.0.0
 */
export function DealItemPickerOptionGroup(props) {
    const { style, title, badge, collapse, index } = Object.assign({ style: 'normal', collapse: false }, props);
    const [collapsed, setCollapsed] = useState(collapse);
    function onCollapseButtonPress() {
        const element = document.getElementById(index);
        setCollapsed((collapsed) => !collapsed);
        if (element) {
            if (collapsed) {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'nearest'
                });
            }
            else {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'end',
                    inline: 'nearest'
                });
            }
        }
    }
    const className = classNames('deal-item-picker-option-group', 'deal-item-picker-option-group--' + style, { 'deal-item-picker-option-group--is-collapsed': collapsed }, props.className);
    return (React.createElement("div", { className: className, id: index },
        React.createElement("div", { className: "deal-item-picker-option-group-head", onClick: onCollapseButtonPress },
            React.createElement("div", { className: "deal-item-picker-option-group-head-main" },
                React.createElement(Text, { className: "deal-item-picker-option-group-title", value: title }),
                React.createElement(Text, { className: "deal-item-picker-option-group-badge", value: badge })),
            React.createElement(Button, { className: "deal-item-picker-option-group-collapse-button", style: "picto", picto: "chevron-up" })),
        React.createElement("div", { className: "deal-item-picker-option-group-body" }, props.children)));
}
